import React from "react";
import { Row } from "reactstrap";

import QuickRepliesTitle from "./QuickRepliesTitle";

export default function MenuButtons() {
  return (
    <div>
      <div className="p-3" style={{ height: "58px" }}>
        <Row>
          <QuickRepliesTitle />
        </Row>
      </div>
      <hr />
    </div>
  );
}
